import { track } from "@amplitude/analytics-browser";
import { formatDate } from '@angular/common';
import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { environment } from '../../../environments/environment';
import { SyslogService } from '../services/syslog.service';

@Component({
  selector: 'app-view-or-download',
  templateUrl: './view-or-download.component.html'
})
export class ViewOrDownloadComponent implements ICellRendererAngularComp {
  url: string = environment.deviceHealthSyslogs;

  serialNumber: string;
  requestedDate: Date;
  fileId: string;
  display: boolean;
  loading: boolean;

  get downloadButtonLabel(): string {
    return this.loading ? "Loading..." : "Download";
  }

  constructor(private syslogService: SyslogService) { }

  agInit(params: ICellRendererParams<any, any>): void {
    this.setFields(params);
  }

  refresh(params: ICellRendererParams<any, any>): boolean {
    this.setFields(params);
    return true;
  }

  setFields(params: ICellRendererParams<any, any>): void {
    this.display = params.data.status === 'COMPLETED';

    this.serialNumber = params.data.serialNumber;
    this.requestedDate = params.data.requestedDate;
    this.fileId = params.data.fileId;
  }

  async onClickView(e: Event) {
    e.preventDefault();
    track('Syslog View Button Clicked', {
      serialNumber: this.serialNumber,
      requestedDate: this.requestedDate
    });

    window.open(`${this.url}/syslogs/${this.fileId}`);
  }

  async onClickDownload(e: Event) {
    e.preventDefault();
    track('Syslog Download Button Clicked', {
      serialNumber: this.serialNumber,
      requestedDate: this.requestedDate
    });

    await this.download();
  }

  async download(): Promise<void> {
    this.loading = true;
    let syslogBlob = await this.syslogService.getSyslogBlob(this.fileId);
    let formattedDate = formatDate(this.requestedDate, 'MMM-d-yy_h-mma', 'en-US');

    let objectUrl = this.createBlobUrl(syslogBlob);
    let link = this.createBlobUrlElement(objectUrl, `debug_${this.serialNumber}_${formattedDate}.log`);
    this.clickBlobLink(link);
    this.removeBlobData(objectUrl, link);
    this.loading = false;
  }

  public removeBlobData(blobUrl: string, link: HTMLAnchorElement) {
    setTimeout(() => {
      // For Firefox it is necessary to delay revoking the ObjectURL
      window.URL.revokeObjectURL(blobUrl);
      link.remove();
    }, 100);
  }

  public createBlobUrlElement(link: string, name: string): HTMLAnchorElement {
    const element = document.createElement('a');
    element.href = link;
    element.download = name;
    return element;
  }

  public createBlobUrl(blob: Blob): string {
    return window.URL.createObjectURL(blob);
  }

  public clickBlobLink(link: HTMLAnchorElement) {
    // this is necessary as link.click() does not work on the latest firefox
    link.dispatchEvent(
      new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      })
    );
  }

  ngOnInit(): void {
  }
}
